module.exports = __webpack_public_path__ + "img/ETC.32ed41f6.png";